<template>
  <div class="contact">
      <section>
        <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d28908.337710365027!2d121.5728658184064!3d25.083500672736335!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3442ac8cce7a9b6d%3A0x377d7129bd402c63!2zMTE05Y-w5YyX5biC5YWn5rmW5Y2A!5e0!3m2!1szh-TW!2stw!4v1511439341322" width="100%" height="450" frameborder="0" style="border:0" allowfullscreen></iframe>
      </section>
      <section>
        <div class="container">
          <div class="columns">
            <div class="column is-7 info">
              <h3 class="subtitle is-2">世源科技有限公司</h3>
                 <ul>
                  <li><span class="icon"><i class="fa fa-map-marker" aria-hidden="true"></i></span>樂土材料皆宅配到指定地址，當天下午兩點前確認訂單，隔天可送達。</li>
                  <li><a href="mailto:service@ezarch.com.tw"><span class="icon"><i class="fa fa-envelope-o fa-lg" aria-hidden="true"></i></span>service@ezarch.com.tw</a></li>
                  <li><a href="tel:0287976155"><span class="icon"><i class="fa fa-phone fa-lg" aria-hidden="true"></i></span>02-87976155</a></li>
                  <li><a href="tel:0931247688"><span class="icon"><i class="fa fa-mobile fa-lg" aria-hidden="true"></i></span>0931-247-688</a></li>
                  <li><span class="icon"><i class="fa fa-calendar" aria-hidden="true"></i></span>週一至週五 9:00-17:00</li>
                  <li><span class="icon"><i class="fa fa-comments" aria-hidden="true"></i></span>非服務時段請<a href="https://line.me/ti/p/%40xqw0055x" target="_blank"><img class="line-icon" border="0" alt="好友人數" src="https://scdn.line-apps.com/n/line_regulation/files/ver2/LINE_Icon.png" width="36" height="36"></a>留言</li>
                </ul>
              </h3>
            </div>
            <div class="column">
              <div class="video-container">
                <iframe src="https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2Fezarchs&tabs&width=500&height=214&small_header=false&adapt_container_width=true&hide_cover=false&show_facepile=true&appId=1350135241775221" width="100%" height="214" style="border:none;overflow:hidden" scrolling="no" frameborder="0" allowTransparency="true"></iframe>
              </div>
            </div>
        </div>   
        </div>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  name: 'contact'
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="sass" scoped>
@import '../mq'

.video-container
  position: relative
  padding-bottom: 56.25%
  padding-top: 30px
  height: 0
  overflow: hidden
  iframe
    position: absolute
    top: 0
    left: 0
    width: 100%
    height: 100%
    
.contact 
  .column 
    padding: 3rem
  .info
    h3
      +mobile
        font-size: 1.7rem
    li 
      line-height: 2
      font-size: 1.3rem
      +mobile
        font-size: 1rem
      color: #666
      .line-icon
        display: inline-block
        margin: 0 5px
      a 
        color: #666
      .icon
        margin-right: 10px
</style>



// WEBPACK FOOTER //
// src/components/Contact.vue